import React, { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { FormBuilderContextProvider } from 'lib/context/FormBuilder/FormBuilderContextProvider';
import { useForms } from 'lib/hooks/queries/forms/useForms';
import usePageTitle from 'lib/hooks/usePageTitle';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import EditFormModal from './EditFormModal';
import { DEFAULT_FILTERS, defaultColumns } from './lib/helpers';

const FormBuilder = () => {
  usePageTitle('Forms');

  const practice = useRecoilValue(currentPractice);

  const columnDefs = useMemo(() => defaultColumns(practice?.timezone), [practice?.timezone]);

  return (
    <FormBuilderContextProvider>
      <AgTablePage
        ModalComponent={EditFormModal}
        defaultColumns={columnDefs}
        defaultFilters={DEFAULT_FILTERS}
        useData={useForms}
        name="forms"
      />
    </FormBuilderContextProvider>
  );
};

export default FormBuilder;
